export default __webpack_public_path__ + "static/logo-identity-portal-ad52250df876df187473ba545f9c5c23.png";